import React, {useState} from 'react'
import '../../../styles/containers/Prayer/components/worship-option-card.scss';
import useMoengage from '../../../hooks/useMoengage';
function WorshipOptionCard({position, worshipOptionObj, setSelectedWorshipOptionObj}) {
    const [selected, setSelected] = useState(false);
    const trackEvent = useMoengage()[1];

    const handleClick = () => {
        if(selected) {
            return;
        }
        trackEvent('worship_interacted', {
            symbol: position
        })
        setSelected(true);
        setSelectedWorshipOptionObj(worshipOptionObj);
    }
    return (
        <div className={`d-flex justify-content-center align-items-center worship-option-card-container ${selected?'worship-option-disabled':''}`} onClick={handleClick}>
            {selected?<worshipOptionObj.disabledOptionImage/>:<worshipOptionObj.enabledOptionImage/>}
        </div>
    )
}

export default WorshipOptionCard
